import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Box, Container } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EmailSignIn from "../components/auth/EmailSignIn";
import EmailRegister from "../components/auth/EmailRegister";
import logo from "../assets/wattlenest.png";

const Login: React.FC = () => {
  const [emailSent, setEmailSent] = useState(false);
  const [showRegister, setShowRegister] = useState(false);

  const handleSignInSuccess = () => {
    setEmailSent(true);
  };

  const handlePasswordSignInSuccess = () => {
    // For password sign-in, we don't need to show "check email"
    // The component will handle the redirect automatically
  };

  const handleRegisterSuccess = () => {
    // Registration successful, redirect will be handled by component
  };

  const handleBackToLogin = () => {
    setShowRegister(false);
    setEmailSent(false);
  };

  const handleShowRegister = () => {
    setShowRegister(true);
  };

  return (
    <Box className="min-h-screen bg-gray-100 py-12 px-4">
      <Container maxWidth="sm">
        <Box className="mb-6 text-gray-100">
          <Link to="/" className="inline-block text-gold">
            <button
              type="button"
              className="rounded-lg x-2 py-1 text-sm text-gray-500 shadow-xs hover:bg-gray-100"
            >
              <ArrowBackIcon aria-hidden="true" className="-ml-0.5 size-5" />
              Back to Home
            </button>
          </Link>
        </Box>
        <img
          alt="Wattlenest"
          src={logo}
          className="h-20 w-auto mx-auto mb-10"
        />
        {showRegister ? (
          <EmailRegister
            onRegisterSuccess={handleRegisterSuccess}
            onBackToLogin={handleBackToLogin}
          />
        ) : emailSent ? (
          <div className="p-6 w-full max-w-md mx-auto bg-white rounded-lg shadow-md">
            <h2 className="text-base font-semibold leading-7 text-gold text-center">
              Athlete Portal
            </h2>
            <h2 className="text-2xl font-bold mb-3 text-center text-gray-800">
              Check your email
            </h2>
            <p className="text-center mb-5">
              {" "}
              We've sent you an email with a magic link. Click the link to
              complete the sign-in process.
            </p>

            <div className="bg-gray-100 p-4 rounded-lg mb-4 text-left text-xs">
              <p className="font-bold mb-2">Important for Mobile Users:</p>
              <ul className="list-disc pl-5 space-y-2">
                <li>
                  <p>
                    <strong>Open the email in your device's browser</strong>{" "}
                    instead of your email app for the best experience.
                  </p>
                </li>
                <li>
                  <p>
                    If you click the link in Gmail, tap "..." and choose{" "}
                    <strong>"Open in browser"</strong> when prompted.
                  </p>
                </li>
                <li>
                  <p>
                    On iOS, you may need to tap and hold the link, then select{" "}
                    <strong>"Open in Safari"</strong> or your preferred browser.
                  </p>
                </li>
              </ul>
            </div>

            <p className="text-xs text-gray-400">
              Don't see the email? Check your spam folder.
            </p>
          </div>
        ) : (
          <EmailSignIn
            onSignInSuccess={handleSignInSuccess}
            onPasswordSignInSuccess={handlePasswordSignInSuccess}
            onShowRegister={handleShowRegister}
          />
        )}
      </Container>
    </Box>
  );
};

export default Login;
